import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Ro... Remove this comment to see the full error message
import { RouterHistory } from 'react-router';

import { RandomGradProgramsBlockData } from 'api/cms';
import { FilestackImageData, RandomGradProgram } from 'api/types/shared.types';
import { TileCarousel } from 'components/TileCarousel';
import { shuffleArray } from 'utils/functional';
import { getJson } from 'utils/http';
import { listingSearchHomePath } from 'utils/searchHomePages';

const getGradPrograms = (areasOfStudy: string[] | null | undefined) => {
  const args = queryString.stringify({
    area: areasOfStudy || [],
  });
  const url = `/data/website/random-grad-programs?${args}`;
  return getJson(url).then(
    ({ gradPrograms }: { gradPrograms: Array<RandomGradProgram> }) =>
      gradPrograms.map((gradProgram) => ({
        city: gradProgram.addressCity,
        id: gradProgram.id,
        logo: gradProgram.logo,
        orgName: gradProgram.schoolName,
        name: gradProgram.name,
        state: gradProgram.addressStateCode,
        url: gradProgram.url,
      }))
  );
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const RandomGradProgramsBlock = ({
  data: { areasOfStudy, headline },
  history,
}: {
  data: RandomGradProgramsBlockData;
  history: RouterHistory;
}) => {
  const [gradPrograms, setGradPrograms] = useState([]);
  useEffect(() => {
    getGradPrograms(areasOfStudy).then(
      (
        programs: Array<{
          city?: string;
          id?: string;
          logo?: FilestackImageData;
          objectID?: string;
          orgName?: string;
          name?: string;
          state?: string;
          url?:
            | string
            | {
                en: string;
                es: string;
                pt: string;
              };
        }>
      ) => {
        setGradPrograms(shuffleArray(programs));
      }
    );
  }, [areasOfStudy]);
  return (
    // <>
    <TileCarousel
      headline={headline}
      results={gradPrograms}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ headline: string; results: any[]; history:... Remove this comment to see the full error message
      history={history}
      seeAllText={
        /* TRANSLATORS: Link to grad program search */
        getText('See all Grad Programs')
      }
      seeAllUrl={`${listingSearchHomePath('GRAD_PROGRAM')}?q=`}
      listingType="GRAD_PROGRAM"
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default RandomGradProgramsBlock;
